/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './axauth-service-schema-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './axauth-service-schema-types';
const defaultOptions = {} as const;
export type IdpUserStoresQueryVariables = Exact<{
  filter?: Types.IdpUserStoreFilter | null | undefined;
  orderBy?: Array<Types.IdpUserStoresOrderBy> | Types.IdpUserStoresOrderBy | null | undefined;
  after?: any;
}>;


export type IdpUserStoresQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, name: string, category: Types.UserStoreCategory, forgotPasswordWebhook: string | null, userSignUpWebhook: string | null, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string }> } | null, nonFiltered: { totalCount: number } | null };

export type RegisterOAuthClientMutationVariables = Exact<{
  input: Types.RegisterOAuthClientInput;
}>;


export type RegisterOAuthClientMutation = { registerOAuthClient: { clientId: string, clientSecret: string } };

export type GenerateOAuthClientSecretMutationVariables = Exact<{
  input: Types.GenerateOAuthClientSecretInput;
}>;


export type GenerateOAuthClientSecretMutation = { generateOAuthClientSecret: { newClientSecret: string } };

export type DeleteOAuthClientMutationVariables = Exact<{
  input: Types.DeleteOAuthClientInput;
}>;


export type DeleteOAuthClientMutation = { deleteOAuthClient: { success: boolean } };

export type UpdateOAuthClientMutationVariables = Exact<{
  input: Types.UpdateOAuthClientInput;
}>;


export type UpdateOAuthClientMutation = { updateOAuthClient: { clientId: string, clientName: string, clientSecret: string, allowUserSignUp: boolean, redirectUris: Array<string> | null } };

export type GetOAuthClientQueryVariables = Exact<{
  id: string;
}>;


export type GetOAuthClientQuery = { oAuthClient: { allowUserSignUp: boolean, clientId: string, clientName: string, clientSecret: string, createdAt: any, createdBy: string | null, redirectUris: Array<string> | null, updatedAt: any, updatedBy: string | null, userStoreName: string } };

export type OAuthClientsQueryVariables = Exact<{
  filter?: Types.OAuthClientFilter | null | undefined;
  condition?: Types.OAuthClientCondition | null | undefined;
  orderBy?: Array<Types.OAuthClientsOrderBy> | Types.OAuthClientsOrderBy | null | undefined;
  after?: any;
}>;


export type OAuthClientsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: string | null, name: string | null, allowUserSignUp: boolean | null, createdAt: any, createdBy: string | null, updatedAt: any, updatedBy: string | null }> } | null, nonFiltered: { totalCount: number } | null };

export type CreateIdpUserMutationVariables = Exact<{
  input: Types.CreateIdpUserInput;
}>;


export type CreateIdpUserMutation = { createIdpUser: { idpUser: { id: any, firstName: string | null, lastName: string | null, email: string, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null } | null };

export type IdpUserQueryVariables = Exact<{
  id: any;
}>;


export type IdpUserQuery = { idpUser: { id: any, firstName: string | null, lastName: string | null, email: string, status: Types.UserStatus, tenantId: any, environmentId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, emailVerified: boolean, idpUserStore: { name: string, category: Types.UserStoreCategory } | null } | null };

export type UpdateIdpUserMutationVariables = Exact<{
  input: Types.UpdateIdpUserInput;
}>;


export type UpdateIdpUserMutation = { updateIdpUser: { clientMutationId: string | null, idpUser: { firstName: string | null, lastName: string | null, status: Types.UserStatus, updatedAt: any, updatedBy: string, emailVerified: boolean } | null } | null };

export type DeleteIdpUserMutationVariables = Exact<{
  input: Types.DeleteIdpUserInput;
}>;


export type DeleteIdpUserMutation = { deleteIdpUser: { clientMutationId: string | null } | null };

export type ResetIdpUserPasswordMutationVariables = Exact<{
  input: Types.ResetIdpUserPasswordInput;
}>;


export type ResetIdpUserPasswordMutation = { resetIdpUserPassword: { newPassword: string, idpUser: { updatedAt: any, updatedBy: string } | null } };

export type CreateIdpUserStoreMutationVariables = Exact<{
  input: Types.CreateIdpUserStoreInput;
}>;


export type CreateIdpUserStoreMutation = { createIdpUserStore: { idpUserStore: { id: any, name: string } | null } | null };

export type CreateForgotPasswordWebHookSecretMutationVariables = Exact<{
  input: Types.GenerateResetPasswordWebhookSecretInput;
}>;


export type CreateForgotPasswordWebHookSecretMutation = { generateResetPasswordWebhookSecret: { secret: string } };

export type ClearForgotPasswordWebHookSecretMutationVariables = Exact<{
  input: Types.ClearResetPasswordWebhookSecretInput;
}>;


export type ClearForgotPasswordWebHookSecretMutation = { clearResetPasswordWebhookSecret: { deletedSecret: string } };

export type CreateMigrationWebHookSecretMutationVariables = Exact<{
  input: Types.GenerateMigrationWebhookSecretInput;
}>;


export type CreateMigrationWebHookSecretMutation = { generateMigrationWebhookSecret: { secret: string } };

export type ClearMigrationWebHookSecretMutationVariables = Exact<{
  input: Types.ClearMigrationWebhookSecretInput;
}>;


export type ClearMigrationWebHookSecretMutation = { clearMigrationWebhookSecret: { deletedSecret: string } };

export type CreateUserSignUpWebHookSecretMutationVariables = Exact<{
  input: Types.GenerateUserSignUpWebhookSecretInput;
}>;


export type CreateUserSignUpWebHookSecretMutation = { generateUserSignUpWebhookSecret: { secret: string } };

export type ClearUserSignUpWebHookSecretMutationVariables = Exact<{
  input: Types.ClearUserSignUpWebhookSecretInput;
}>;


export type ClearUserSignUpWebHookSecretMutation = { clearUserSignUpWebhookSecret: { deletedSecret: string } };

export type IdpUserStoreQueryVariables = Exact<{
  id: any;
}>;


export type IdpUserStoreQuery = { idpUserStore: { id: any, name: string, category: Types.UserStoreCategory, forgotPasswordWebhook: string | null, userSignUpWebhook: string | null, migrationWebhook: string | null, tenantId: any, environmentId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, userSignUpWebhookSecretIsSet: boolean, resetPasswordWebhookSecretIsSet: boolean, migrationWebhookSecretIsSet: boolean, enforceStrictPasswordPolicy: boolean } | null };

export type UpdateIdpUserStoreMutationVariables = Exact<{
  input: Types.UpdateIdpUserStoreInput;
}>;


export type UpdateIdpUserStoreMutation = { updateIdpUserStore: { clientMutationId: string | null, idpUserStore: { name: string, forgotPasswordWebhook: string | null, userSignUpWebhook: string | null, migrationWebhook: string | null, enforceStrictPasswordPolicy: boolean, updatedAt: any, updatedBy: string } | null } | null };

export type DeleteIdpUserStoreMutationVariables = Exact<{
  input: Types.DeleteIdpUserStoreInput;
}>;


export type DeleteIdpUserStoreMutation = { deleteIdpUserStore: { clientMutationId: string | null } | null };

export type IdpUserStoreCountQueryVariables = Exact<{
  idpUserCondition?: Types.IdpUserCondition | null | undefined;
  oAuthClientCondition?: Types.OAuthClientCondition | null | undefined;
}>;


export type IdpUserStoreCountQuery = { idpUsers: { totalCount: number } | null, oAuthClients: { totalCount: number } | null };

export type UserCountAffectedByExclusionPatternQueryVariables = Exact<{
  filter: Types.IdpUserFilter;
}>;


export type UserCountAffectedByExclusionPatternQuery = { idpUsers: { totalCount: number } | null };

export type EmailExclusionPatternsQueryVariables = Exact<{
  filter?: Types.EmailExclusionPatternFilter | null | undefined;
  orderBy?: Array<Types.EmailExclusionPatternsOrderBy> | Types.EmailExclusionPatternsOrderBy | null | undefined;
  after?: any;
}>;


export type EmailExclusionPatternsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, emailPattern: string, userStoreId: any, affectedUserCount: number, tenantId: any, environmentId: any, createdAt: any, updatedAt: any, idpUserStore: { idpUsers: { totalCount: number } } | null }> } | null, nonFiltered: { totalCount: number } | null };

export type UpdateEmailExclusionPatternMutationVariables = Exact<{
  input: Types.UpdateEmailExclusionPatternInput;
}>;


export type UpdateEmailExclusionPatternMutation = { updateEmailExclusionPattern: { clientMutationId: string | null, emailExclusionPattern: { id: any, emailPattern: string, userStoreId: any, updatedAt: any, updatedBy: string } | null } | null };

export type DeleteEmailExclusionPatternMutationVariables = Exact<{
  input: Types.DeleteEmailExclusionPatternInput;
}>;


export type DeleteEmailExclusionPatternMutation = { deleteEmailExclusionPattern: { clientMutationId: string | null } | null };

export type CreateEmailExclusionPatternMutationVariables = Exact<{
  input: Types.CreateEmailExclusionPatternInput;
}>;


export type CreateEmailExclusionPatternMutation = { createEmailExclusionPattern: { emailExclusionPattern: { id: any, emailPattern: string, userStoreId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null } | null };

export type IdpUsersQueryVariables = Exact<{
  filter?: Types.IdpUserFilter | null | undefined;
  condition?: Types.IdpUserCondition | null | undefined;
  orderBy?: Array<Types.IdpUsersOrderBy> | Types.IdpUsersOrderBy | null | undefined;
  after?: any;
}>;


export type IdpUsersQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, firstName: string | null, lastName: string | null, email: string, status: Types.UserStatus, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, emailVerified: boolean, isAffectedByExclusionPattern: boolean }> } | null, nonFiltered: { totalCount: number } | null };


export const IdpUserStoresDocument = gql`
    query IdpUserStores($filter: IdpUserStoreFilter, $orderBy: [IdpUserStoresOrderBy!], $after: Cursor) {
  filtered: idpUserStores(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      category
      forgotPasswordWebhook
      userSignUpWebhook
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  nonFiltered: idpUserStores {
    totalCount
  }
}
    `;

/**
 * __useIdpUserStoresQuery__
 *
 * To run a query within a React component, call `useIdpUserStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpUserStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpUserStoresQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIdpUserStoresQuery(baseOptions?: Apollo.QueryHookOptions<IdpUserStoresQuery, IdpUserStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpUserStoresQuery, IdpUserStoresQueryVariables>(IdpUserStoresDocument, options);
      }
export function useIdpUserStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpUserStoresQuery, IdpUserStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpUserStoresQuery, IdpUserStoresQueryVariables>(IdpUserStoresDocument, options);
        }
export type IdpUserStoresQueryHookResult = ReturnType<typeof useIdpUserStoresQuery>;
export type IdpUserStoresLazyQueryHookResult = ReturnType<typeof useIdpUserStoresLazyQuery>;
export type IdpUserStoresQueryResult = Apollo.QueryResult<IdpUserStoresQuery, IdpUserStoresQueryVariables>;
export const RegisterOAuthClientDocument = gql`
    mutation RegisterOAuthClient($input: RegisterOAuthClientInput!) {
  registerOAuthClient(input: $input) {
    clientId
    clientSecret
  }
}
    `;
export type RegisterOAuthClientMutationFn = Apollo.MutationFunction<RegisterOAuthClientMutation, RegisterOAuthClientMutationVariables>;

/**
 * __useRegisterOAuthClientMutation__
 *
 * To run a mutation, you first call `useRegisterOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerOAuthClientMutation, { data, loading, error }] = useRegisterOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<RegisterOAuthClientMutation, RegisterOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterOAuthClientMutation, RegisterOAuthClientMutationVariables>(RegisterOAuthClientDocument, options);
      }
export type RegisterOAuthClientMutationHookResult = ReturnType<typeof useRegisterOAuthClientMutation>;
export type RegisterOAuthClientMutationResult = Apollo.MutationResult<RegisterOAuthClientMutation>;
export type RegisterOAuthClientMutationOptions = Apollo.BaseMutationOptions<RegisterOAuthClientMutation, RegisterOAuthClientMutationVariables>;
export const GenerateOAuthClientSecretDocument = gql`
    mutation GenerateOAuthClientSecret($input: GenerateOAuthClientSecretInput!) {
  generateOAuthClientSecret(input: $input) {
    newClientSecret
  }
}
    `;
export type GenerateOAuthClientSecretMutationFn = Apollo.MutationFunction<GenerateOAuthClientSecretMutation, GenerateOAuthClientSecretMutationVariables>;

/**
 * __useGenerateOAuthClientSecretMutation__
 *
 * To run a mutation, you first call `useGenerateOAuthClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOAuthClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOAuthClientSecretMutation, { data, loading, error }] = useGenerateOAuthClientSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOAuthClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOAuthClientSecretMutation, GenerateOAuthClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOAuthClientSecretMutation, GenerateOAuthClientSecretMutationVariables>(GenerateOAuthClientSecretDocument, options);
      }
export type GenerateOAuthClientSecretMutationHookResult = ReturnType<typeof useGenerateOAuthClientSecretMutation>;
export type GenerateOAuthClientSecretMutationResult = Apollo.MutationResult<GenerateOAuthClientSecretMutation>;
export type GenerateOAuthClientSecretMutationOptions = Apollo.BaseMutationOptions<GenerateOAuthClientSecretMutation, GenerateOAuthClientSecretMutationVariables>;
export const DeleteOAuthClientDocument = gql`
    mutation DeleteOAuthClient($input: DeleteOAuthClientInput!) {
  deleteOAuthClient(input: $input) {
    success
  }
}
    `;
export type DeleteOAuthClientMutationFn = Apollo.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;

/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>(DeleteOAuthClientDocument, options);
      }
export type DeleteOAuthClientMutationHookResult = ReturnType<typeof useDeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationResult = Apollo.MutationResult<DeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationOptions = Apollo.BaseMutationOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export const UpdateOAuthClientDocument = gql`
    mutation UpdateOAuthClient($input: UpdateOAuthClientInput!) {
  updateOAuthClient(input: $input) {
    clientId
    clientName
    clientSecret
    allowUserSignUp
    redirectUris
  }
}
    `;
export type UpdateOAuthClientMutationFn = Apollo.MutationFunction<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;

/**
 * __useUpdateOAuthClientMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthClientMutation, { data, loading, error }] = useUpdateOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>(UpdateOAuthClientDocument, options);
      }
export type UpdateOAuthClientMutationHookResult = ReturnType<typeof useUpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationResult = Apollo.MutationResult<UpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationOptions = Apollo.BaseMutationOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;
export const GetOAuthClientDocument = gql`
    query GetOAuthClient($id: String!) {
  oAuthClient(id: $id) {
    allowUserSignUp
    clientId
    clientName
    clientSecret
    createdAt
    createdBy
    redirectUris
    updatedAt
    updatedBy
    userStoreName
  }
}
    `;

/**
 * __useGetOAuthClientQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOAuthClientQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
      }
export function useGetOAuthClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
        }
export type GetOAuthClientQueryHookResult = ReturnType<typeof useGetOAuthClientQuery>;
export type GetOAuthClientLazyQueryHookResult = ReturnType<typeof useGetOAuthClientLazyQuery>;
export type GetOAuthClientQueryResult = Apollo.QueryResult<GetOAuthClientQuery, GetOAuthClientQueryVariables>;
export const OAuthClientsDocument = gql`
    query OAuthClients($filter: OAuthClientFilter, $condition: OAuthClientCondition, $orderBy: [OAuthClientsOrderBy!], $after: Cursor) {
  filtered: oAuthClients(
    filter: $filter
    condition: $condition
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      allowUserSignUp
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  nonFiltered: oAuthClients(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useOAuthClientsQuery__
 *
 * To run a query within a React component, call `useOAuthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthClientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOAuthClientsQuery(baseOptions?: Apollo.QueryHookOptions<OAuthClientsQuery, OAuthClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OAuthClientsQuery, OAuthClientsQueryVariables>(OAuthClientsDocument, options);
      }
export function useOAuthClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OAuthClientsQuery, OAuthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OAuthClientsQuery, OAuthClientsQueryVariables>(OAuthClientsDocument, options);
        }
export type OAuthClientsQueryHookResult = ReturnType<typeof useOAuthClientsQuery>;
export type OAuthClientsLazyQueryHookResult = ReturnType<typeof useOAuthClientsLazyQuery>;
export type OAuthClientsQueryResult = Apollo.QueryResult<OAuthClientsQuery, OAuthClientsQueryVariables>;
export const CreateIdpUserDocument = gql`
    mutation CreateIdpUser($input: CreateIdpUserInput!) {
  createIdpUser(input: $input) {
    idpUser {
      id
      firstName
      lastName
      email
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateIdpUserMutationFn = Apollo.MutationFunction<CreateIdpUserMutation, CreateIdpUserMutationVariables>;

/**
 * __useCreateIdpUserMutation__
 *
 * To run a mutation, you first call `useCreateIdpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdpUserMutation, { data, loading, error }] = useCreateIdpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdpUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdpUserMutation, CreateIdpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdpUserMutation, CreateIdpUserMutationVariables>(CreateIdpUserDocument, options);
      }
export type CreateIdpUserMutationHookResult = ReturnType<typeof useCreateIdpUserMutation>;
export type CreateIdpUserMutationResult = Apollo.MutationResult<CreateIdpUserMutation>;
export type CreateIdpUserMutationOptions = Apollo.BaseMutationOptions<CreateIdpUserMutation, CreateIdpUserMutationVariables>;
export const IdpUserDocument = gql`
    query IdpUser($id: UUID!) {
  idpUser(id: $id) {
    id
    firstName
    lastName
    email
    status
    idpUserStore {
      name
      category
    }
    tenantId
    environmentId
    createdAt
    createdBy
    updatedAt
    updatedBy
    emailVerified
  }
}
    `;

/**
 * __useIdpUserQuery__
 *
 * To run a query within a React component, call `useIdpUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdpUserQuery(baseOptions: Apollo.QueryHookOptions<IdpUserQuery, IdpUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpUserQuery, IdpUserQueryVariables>(IdpUserDocument, options);
      }
export function useIdpUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpUserQuery, IdpUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpUserQuery, IdpUserQueryVariables>(IdpUserDocument, options);
        }
export type IdpUserQueryHookResult = ReturnType<typeof useIdpUserQuery>;
export type IdpUserLazyQueryHookResult = ReturnType<typeof useIdpUserLazyQuery>;
export type IdpUserQueryResult = Apollo.QueryResult<IdpUserQuery, IdpUserQueryVariables>;
export const UpdateIdpUserDocument = gql`
    mutation UpdateIdpUser($input: UpdateIdpUserInput!) {
  updateIdpUser(input: $input) {
    clientMutationId
    idpUser {
      firstName
      lastName
      status
      updatedAt
      updatedBy
      emailVerified
    }
  }
}
    `;
export type UpdateIdpUserMutationFn = Apollo.MutationFunction<UpdateIdpUserMutation, UpdateIdpUserMutationVariables>;

/**
 * __useUpdateIdpUserMutation__
 *
 * To run a mutation, you first call `useUpdateIdpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdpUserMutation, { data, loading, error }] = useUpdateIdpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdpUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdpUserMutation, UpdateIdpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdpUserMutation, UpdateIdpUserMutationVariables>(UpdateIdpUserDocument, options);
      }
export type UpdateIdpUserMutationHookResult = ReturnType<typeof useUpdateIdpUserMutation>;
export type UpdateIdpUserMutationResult = Apollo.MutationResult<UpdateIdpUserMutation>;
export type UpdateIdpUserMutationOptions = Apollo.BaseMutationOptions<UpdateIdpUserMutation, UpdateIdpUserMutationVariables>;
export const DeleteIdpUserDocument = gql`
    mutation DeleteIdpUser($input: DeleteIdpUserInput!) {
  deleteIdpUser(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteIdpUserMutationFn = Apollo.MutationFunction<DeleteIdpUserMutation, DeleteIdpUserMutationVariables>;

/**
 * __useDeleteIdpUserMutation__
 *
 * To run a mutation, you first call `useDeleteIdpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdpUserMutation, { data, loading, error }] = useDeleteIdpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIdpUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdpUserMutation, DeleteIdpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdpUserMutation, DeleteIdpUserMutationVariables>(DeleteIdpUserDocument, options);
      }
export type DeleteIdpUserMutationHookResult = ReturnType<typeof useDeleteIdpUserMutation>;
export type DeleteIdpUserMutationResult = Apollo.MutationResult<DeleteIdpUserMutation>;
export type DeleteIdpUserMutationOptions = Apollo.BaseMutationOptions<DeleteIdpUserMutation, DeleteIdpUserMutationVariables>;
export const ResetIdpUserPasswordDocument = gql`
    mutation ResetIdpUserPassword($input: ResetIdpUserPasswordInput!) {
  resetIdpUserPassword(input: $input) {
    newPassword
    idpUser {
      updatedAt
      updatedBy
    }
  }
}
    `;
export type ResetIdpUserPasswordMutationFn = Apollo.MutationFunction<ResetIdpUserPasswordMutation, ResetIdpUserPasswordMutationVariables>;

/**
 * __useResetIdpUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetIdpUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetIdpUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetIdpUserPasswordMutation, { data, loading, error }] = useResetIdpUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetIdpUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetIdpUserPasswordMutation, ResetIdpUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetIdpUserPasswordMutation, ResetIdpUserPasswordMutationVariables>(ResetIdpUserPasswordDocument, options);
      }
export type ResetIdpUserPasswordMutationHookResult = ReturnType<typeof useResetIdpUserPasswordMutation>;
export type ResetIdpUserPasswordMutationResult = Apollo.MutationResult<ResetIdpUserPasswordMutation>;
export type ResetIdpUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetIdpUserPasswordMutation, ResetIdpUserPasswordMutationVariables>;
export const CreateIdpUserStoreDocument = gql`
    mutation CreateIdpUserStore($input: CreateIdpUserStoreInput!) {
  createIdpUserStore(input: $input) {
    idpUserStore {
      id
      name
    }
  }
}
    `;
export type CreateIdpUserStoreMutationFn = Apollo.MutationFunction<CreateIdpUserStoreMutation, CreateIdpUserStoreMutationVariables>;

/**
 * __useCreateIdpUserStoreMutation__
 *
 * To run a mutation, you first call `useCreateIdpUserStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdpUserStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdpUserStoreMutation, { data, loading, error }] = useCreateIdpUserStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdpUserStoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdpUserStoreMutation, CreateIdpUserStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdpUserStoreMutation, CreateIdpUserStoreMutationVariables>(CreateIdpUserStoreDocument, options);
      }
export type CreateIdpUserStoreMutationHookResult = ReturnType<typeof useCreateIdpUserStoreMutation>;
export type CreateIdpUserStoreMutationResult = Apollo.MutationResult<CreateIdpUserStoreMutation>;
export type CreateIdpUserStoreMutationOptions = Apollo.BaseMutationOptions<CreateIdpUserStoreMutation, CreateIdpUserStoreMutationVariables>;
export const CreateForgotPasswordWebHookSecretDocument = gql`
    mutation CreateForgotPasswordWebHookSecret($input: GenerateResetPasswordWebhookSecretInput!) {
  generateResetPasswordWebhookSecret(input: $input) {
    secret
  }
}
    `;
export type CreateForgotPasswordWebHookSecretMutationFn = Apollo.MutationFunction<CreateForgotPasswordWebHookSecretMutation, CreateForgotPasswordWebHookSecretMutationVariables>;

/**
 * __useCreateForgotPasswordWebHookSecretMutation__
 *
 * To run a mutation, you first call `useCreateForgotPasswordWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForgotPasswordWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForgotPasswordWebHookSecretMutation, { data, loading, error }] = useCreateForgotPasswordWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateForgotPasswordWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateForgotPasswordWebHookSecretMutation, CreateForgotPasswordWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForgotPasswordWebHookSecretMutation, CreateForgotPasswordWebHookSecretMutationVariables>(CreateForgotPasswordWebHookSecretDocument, options);
      }
export type CreateForgotPasswordWebHookSecretMutationHookResult = ReturnType<typeof useCreateForgotPasswordWebHookSecretMutation>;
export type CreateForgotPasswordWebHookSecretMutationResult = Apollo.MutationResult<CreateForgotPasswordWebHookSecretMutation>;
export type CreateForgotPasswordWebHookSecretMutationOptions = Apollo.BaseMutationOptions<CreateForgotPasswordWebHookSecretMutation, CreateForgotPasswordWebHookSecretMutationVariables>;
export const ClearForgotPasswordWebHookSecretDocument = gql`
    mutation ClearForgotPasswordWebHookSecret($input: ClearResetPasswordWebhookSecretInput!) {
  clearResetPasswordWebhookSecret(input: $input) {
    deletedSecret
  }
}
    `;
export type ClearForgotPasswordWebHookSecretMutationFn = Apollo.MutationFunction<ClearForgotPasswordWebHookSecretMutation, ClearForgotPasswordWebHookSecretMutationVariables>;

/**
 * __useClearForgotPasswordWebHookSecretMutation__
 *
 * To run a mutation, you first call `useClearForgotPasswordWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearForgotPasswordWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearForgotPasswordWebHookSecretMutation, { data, loading, error }] = useClearForgotPasswordWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearForgotPasswordWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<ClearForgotPasswordWebHookSecretMutation, ClearForgotPasswordWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearForgotPasswordWebHookSecretMutation, ClearForgotPasswordWebHookSecretMutationVariables>(ClearForgotPasswordWebHookSecretDocument, options);
      }
export type ClearForgotPasswordWebHookSecretMutationHookResult = ReturnType<typeof useClearForgotPasswordWebHookSecretMutation>;
export type ClearForgotPasswordWebHookSecretMutationResult = Apollo.MutationResult<ClearForgotPasswordWebHookSecretMutation>;
export type ClearForgotPasswordWebHookSecretMutationOptions = Apollo.BaseMutationOptions<ClearForgotPasswordWebHookSecretMutation, ClearForgotPasswordWebHookSecretMutationVariables>;
export const CreateMigrationWebHookSecretDocument = gql`
    mutation CreateMigrationWebHookSecret($input: GenerateMigrationWebhookSecretInput!) {
  generateMigrationWebhookSecret(input: $input) {
    secret
  }
}
    `;
export type CreateMigrationWebHookSecretMutationFn = Apollo.MutationFunction<CreateMigrationWebHookSecretMutation, CreateMigrationWebHookSecretMutationVariables>;

/**
 * __useCreateMigrationWebHookSecretMutation__
 *
 * To run a mutation, you first call `useCreateMigrationWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMigrationWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMigrationWebHookSecretMutation, { data, loading, error }] = useCreateMigrationWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMigrationWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateMigrationWebHookSecretMutation, CreateMigrationWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMigrationWebHookSecretMutation, CreateMigrationWebHookSecretMutationVariables>(CreateMigrationWebHookSecretDocument, options);
      }
export type CreateMigrationWebHookSecretMutationHookResult = ReturnType<typeof useCreateMigrationWebHookSecretMutation>;
export type CreateMigrationWebHookSecretMutationResult = Apollo.MutationResult<CreateMigrationWebHookSecretMutation>;
export type CreateMigrationWebHookSecretMutationOptions = Apollo.BaseMutationOptions<CreateMigrationWebHookSecretMutation, CreateMigrationWebHookSecretMutationVariables>;
export const ClearMigrationWebHookSecretDocument = gql`
    mutation ClearMigrationWebHookSecret($input: ClearMigrationWebhookSecretInput!) {
  clearMigrationWebhookSecret(input: $input) {
    deletedSecret
  }
}
    `;
export type ClearMigrationWebHookSecretMutationFn = Apollo.MutationFunction<ClearMigrationWebHookSecretMutation, ClearMigrationWebHookSecretMutationVariables>;

/**
 * __useClearMigrationWebHookSecretMutation__
 *
 * To run a mutation, you first call `useClearMigrationWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMigrationWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMigrationWebHookSecretMutation, { data, loading, error }] = useClearMigrationWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearMigrationWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<ClearMigrationWebHookSecretMutation, ClearMigrationWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearMigrationWebHookSecretMutation, ClearMigrationWebHookSecretMutationVariables>(ClearMigrationWebHookSecretDocument, options);
      }
export type ClearMigrationWebHookSecretMutationHookResult = ReturnType<typeof useClearMigrationWebHookSecretMutation>;
export type ClearMigrationWebHookSecretMutationResult = Apollo.MutationResult<ClearMigrationWebHookSecretMutation>;
export type ClearMigrationWebHookSecretMutationOptions = Apollo.BaseMutationOptions<ClearMigrationWebHookSecretMutation, ClearMigrationWebHookSecretMutationVariables>;
export const CreateUserSignUpWebHookSecretDocument = gql`
    mutation CreateUserSignUpWebHookSecret($input: GenerateUserSignUpWebhookSecretInput!) {
  generateUserSignUpWebhookSecret(input: $input) {
    secret
  }
}
    `;
export type CreateUserSignUpWebHookSecretMutationFn = Apollo.MutationFunction<CreateUserSignUpWebHookSecretMutation, CreateUserSignUpWebHookSecretMutationVariables>;

/**
 * __useCreateUserSignUpWebHookSecretMutation__
 *
 * To run a mutation, you first call `useCreateUserSignUpWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSignUpWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSignUpWebHookSecretMutation, { data, loading, error }] = useCreateUserSignUpWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserSignUpWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSignUpWebHookSecretMutation, CreateUserSignUpWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSignUpWebHookSecretMutation, CreateUserSignUpWebHookSecretMutationVariables>(CreateUserSignUpWebHookSecretDocument, options);
      }
export type CreateUserSignUpWebHookSecretMutationHookResult = ReturnType<typeof useCreateUserSignUpWebHookSecretMutation>;
export type CreateUserSignUpWebHookSecretMutationResult = Apollo.MutationResult<CreateUserSignUpWebHookSecretMutation>;
export type CreateUserSignUpWebHookSecretMutationOptions = Apollo.BaseMutationOptions<CreateUserSignUpWebHookSecretMutation, CreateUserSignUpWebHookSecretMutationVariables>;
export const ClearUserSignUpWebHookSecretDocument = gql`
    mutation ClearUserSignUpWebHookSecret($input: ClearUserSignUpWebhookSecretInput!) {
  clearUserSignUpWebhookSecret(input: $input) {
    deletedSecret
  }
}
    `;
export type ClearUserSignUpWebHookSecretMutationFn = Apollo.MutationFunction<ClearUserSignUpWebHookSecretMutation, ClearUserSignUpWebHookSecretMutationVariables>;

/**
 * __useClearUserSignUpWebHookSecretMutation__
 *
 * To run a mutation, you first call `useClearUserSignUpWebHookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearUserSignUpWebHookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearUserSignUpWebHookSecretMutation, { data, loading, error }] = useClearUserSignUpWebHookSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearUserSignUpWebHookSecretMutation(baseOptions?: Apollo.MutationHookOptions<ClearUserSignUpWebHookSecretMutation, ClearUserSignUpWebHookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearUserSignUpWebHookSecretMutation, ClearUserSignUpWebHookSecretMutationVariables>(ClearUserSignUpWebHookSecretDocument, options);
      }
export type ClearUserSignUpWebHookSecretMutationHookResult = ReturnType<typeof useClearUserSignUpWebHookSecretMutation>;
export type ClearUserSignUpWebHookSecretMutationResult = Apollo.MutationResult<ClearUserSignUpWebHookSecretMutation>;
export type ClearUserSignUpWebHookSecretMutationOptions = Apollo.BaseMutationOptions<ClearUserSignUpWebHookSecretMutation, ClearUserSignUpWebHookSecretMutationVariables>;
export const IdpUserStoreDocument = gql`
    query IdpUserStore($id: UUID!) {
  idpUserStore(id: $id) {
    id
    name
    category
    forgotPasswordWebhook
    userSignUpWebhook
    migrationWebhook
    tenantId
    environmentId
    createdAt
    createdBy
    updatedAt
    updatedBy
    userSignUpWebhookSecretIsSet
    resetPasswordWebhookSecretIsSet
    migrationWebhookSecretIsSet
    enforceStrictPasswordPolicy
  }
}
    `;

/**
 * __useIdpUserStoreQuery__
 *
 * To run a query within a React component, call `useIdpUserStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpUserStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpUserStoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdpUserStoreQuery(baseOptions: Apollo.QueryHookOptions<IdpUserStoreQuery, IdpUserStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpUserStoreQuery, IdpUserStoreQueryVariables>(IdpUserStoreDocument, options);
      }
export function useIdpUserStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpUserStoreQuery, IdpUserStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpUserStoreQuery, IdpUserStoreQueryVariables>(IdpUserStoreDocument, options);
        }
export type IdpUserStoreQueryHookResult = ReturnType<typeof useIdpUserStoreQuery>;
export type IdpUserStoreLazyQueryHookResult = ReturnType<typeof useIdpUserStoreLazyQuery>;
export type IdpUserStoreQueryResult = Apollo.QueryResult<IdpUserStoreQuery, IdpUserStoreQueryVariables>;
export const UpdateIdpUserStoreDocument = gql`
    mutation UpdateIdpUserStore($input: UpdateIdpUserStoreInput!) {
  updateIdpUserStore(input: $input) {
    clientMutationId
    idpUserStore {
      name
      forgotPasswordWebhook
      userSignUpWebhook
      migrationWebhook
      enforceStrictPasswordPolicy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateIdpUserStoreMutationFn = Apollo.MutationFunction<UpdateIdpUserStoreMutation, UpdateIdpUserStoreMutationVariables>;

/**
 * __useUpdateIdpUserStoreMutation__
 *
 * To run a mutation, you first call `useUpdateIdpUserStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdpUserStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdpUserStoreMutation, { data, loading, error }] = useUpdateIdpUserStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdpUserStoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdpUserStoreMutation, UpdateIdpUserStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdpUserStoreMutation, UpdateIdpUserStoreMutationVariables>(UpdateIdpUserStoreDocument, options);
      }
export type UpdateIdpUserStoreMutationHookResult = ReturnType<typeof useUpdateIdpUserStoreMutation>;
export type UpdateIdpUserStoreMutationResult = Apollo.MutationResult<UpdateIdpUserStoreMutation>;
export type UpdateIdpUserStoreMutationOptions = Apollo.BaseMutationOptions<UpdateIdpUserStoreMutation, UpdateIdpUserStoreMutationVariables>;
export const DeleteIdpUserStoreDocument = gql`
    mutation DeleteIdpUserStore($input: DeleteIdpUserStoreInput!) {
  deleteIdpUserStore(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteIdpUserStoreMutationFn = Apollo.MutationFunction<DeleteIdpUserStoreMutation, DeleteIdpUserStoreMutationVariables>;

/**
 * __useDeleteIdpUserStoreMutation__
 *
 * To run a mutation, you first call `useDeleteIdpUserStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdpUserStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdpUserStoreMutation, { data, loading, error }] = useDeleteIdpUserStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIdpUserStoreMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdpUserStoreMutation, DeleteIdpUserStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdpUserStoreMutation, DeleteIdpUserStoreMutationVariables>(DeleteIdpUserStoreDocument, options);
      }
export type DeleteIdpUserStoreMutationHookResult = ReturnType<typeof useDeleteIdpUserStoreMutation>;
export type DeleteIdpUserStoreMutationResult = Apollo.MutationResult<DeleteIdpUserStoreMutation>;
export type DeleteIdpUserStoreMutationOptions = Apollo.BaseMutationOptions<DeleteIdpUserStoreMutation, DeleteIdpUserStoreMutationVariables>;
export const IdpUserStoreCountDocument = gql`
    query IdpUserStoreCount($idpUserCondition: IdpUserCondition, $oAuthClientCondition: OAuthClientCondition) {
  idpUsers(condition: $idpUserCondition) {
    totalCount
  }
  oAuthClients(condition: $oAuthClientCondition) {
    totalCount
  }
}
    `;

/**
 * __useIdpUserStoreCountQuery__
 *
 * To run a query within a React component, call `useIdpUserStoreCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpUserStoreCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpUserStoreCountQuery({
 *   variables: {
 *      idpUserCondition: // value for 'idpUserCondition'
 *      oAuthClientCondition: // value for 'oAuthClientCondition'
 *   },
 * });
 */
export function useIdpUserStoreCountQuery(baseOptions?: Apollo.QueryHookOptions<IdpUserStoreCountQuery, IdpUserStoreCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpUserStoreCountQuery, IdpUserStoreCountQueryVariables>(IdpUserStoreCountDocument, options);
      }
export function useIdpUserStoreCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpUserStoreCountQuery, IdpUserStoreCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpUserStoreCountQuery, IdpUserStoreCountQueryVariables>(IdpUserStoreCountDocument, options);
        }
export type IdpUserStoreCountQueryHookResult = ReturnType<typeof useIdpUserStoreCountQuery>;
export type IdpUserStoreCountLazyQueryHookResult = ReturnType<typeof useIdpUserStoreCountLazyQuery>;
export type IdpUserStoreCountQueryResult = Apollo.QueryResult<IdpUserStoreCountQuery, IdpUserStoreCountQueryVariables>;
export const UserCountAffectedByExclusionPatternDocument = gql`
    query UserCountAffectedByExclusionPattern($filter: IdpUserFilter!) {
  idpUsers(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useUserCountAffectedByExclusionPatternQuery__
 *
 * To run a query within a React component, call `useUserCountAffectedByExclusionPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountAffectedByExclusionPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountAffectedByExclusionPatternQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserCountAffectedByExclusionPatternQuery(baseOptions: Apollo.QueryHookOptions<UserCountAffectedByExclusionPatternQuery, UserCountAffectedByExclusionPatternQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCountAffectedByExclusionPatternQuery, UserCountAffectedByExclusionPatternQueryVariables>(UserCountAffectedByExclusionPatternDocument, options);
      }
export function useUserCountAffectedByExclusionPatternLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCountAffectedByExclusionPatternQuery, UserCountAffectedByExclusionPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCountAffectedByExclusionPatternQuery, UserCountAffectedByExclusionPatternQueryVariables>(UserCountAffectedByExclusionPatternDocument, options);
        }
export type UserCountAffectedByExclusionPatternQueryHookResult = ReturnType<typeof useUserCountAffectedByExclusionPatternQuery>;
export type UserCountAffectedByExclusionPatternLazyQueryHookResult = ReturnType<typeof useUserCountAffectedByExclusionPatternLazyQuery>;
export type UserCountAffectedByExclusionPatternQueryResult = Apollo.QueryResult<UserCountAffectedByExclusionPatternQuery, UserCountAffectedByExclusionPatternQueryVariables>;
export const EmailExclusionPatternsDocument = gql`
    query EmailExclusionPatterns($filter: EmailExclusionPatternFilter, $orderBy: [EmailExclusionPatternsOrderBy!], $after: Cursor) {
  filtered: emailExclusionPatterns(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      emailPattern
      userStoreId
      affectedUserCount
      idpUserStore {
        idpUsers(filter: {isAffectedByExclusionPattern: {equalTo: true}}) {
          totalCount
        }
      }
      tenantId
      environmentId
      createdAt
      updatedAt
    }
  }
  nonFiltered: emailExclusionPatterns {
    totalCount
  }
}
    `;

/**
 * __useEmailExclusionPatternsQuery__
 *
 * To run a query within a React component, call `useEmailExclusionPatternsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailExclusionPatternsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailExclusionPatternsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEmailExclusionPatternsQuery(baseOptions?: Apollo.QueryHookOptions<EmailExclusionPatternsQuery, EmailExclusionPatternsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailExclusionPatternsQuery, EmailExclusionPatternsQueryVariables>(EmailExclusionPatternsDocument, options);
      }
export function useEmailExclusionPatternsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailExclusionPatternsQuery, EmailExclusionPatternsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailExclusionPatternsQuery, EmailExclusionPatternsQueryVariables>(EmailExclusionPatternsDocument, options);
        }
export type EmailExclusionPatternsQueryHookResult = ReturnType<typeof useEmailExclusionPatternsQuery>;
export type EmailExclusionPatternsLazyQueryHookResult = ReturnType<typeof useEmailExclusionPatternsLazyQuery>;
export type EmailExclusionPatternsQueryResult = Apollo.QueryResult<EmailExclusionPatternsQuery, EmailExclusionPatternsQueryVariables>;
export const UpdateEmailExclusionPatternDocument = gql`
    mutation UpdateEmailExclusionPattern($input: UpdateEmailExclusionPatternInput!) {
  updateEmailExclusionPattern(input: $input) {
    clientMutationId
    emailExclusionPattern {
      id
      emailPattern
      userStoreId
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateEmailExclusionPatternMutationFn = Apollo.MutationFunction<UpdateEmailExclusionPatternMutation, UpdateEmailExclusionPatternMutationVariables>;

/**
 * __useUpdateEmailExclusionPatternMutation__
 *
 * To run a mutation, you first call `useUpdateEmailExclusionPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailExclusionPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailExclusionPatternMutation, { data, loading, error }] = useUpdateEmailExclusionPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailExclusionPatternMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailExclusionPatternMutation, UpdateEmailExclusionPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailExclusionPatternMutation, UpdateEmailExclusionPatternMutationVariables>(UpdateEmailExclusionPatternDocument, options);
      }
export type UpdateEmailExclusionPatternMutationHookResult = ReturnType<typeof useUpdateEmailExclusionPatternMutation>;
export type UpdateEmailExclusionPatternMutationResult = Apollo.MutationResult<UpdateEmailExclusionPatternMutation>;
export type UpdateEmailExclusionPatternMutationOptions = Apollo.BaseMutationOptions<UpdateEmailExclusionPatternMutation, UpdateEmailExclusionPatternMutationVariables>;
export const DeleteEmailExclusionPatternDocument = gql`
    mutation DeleteEmailExclusionPattern($input: DeleteEmailExclusionPatternInput!) {
  deleteEmailExclusionPattern(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteEmailExclusionPatternMutationFn = Apollo.MutationFunction<DeleteEmailExclusionPatternMutation, DeleteEmailExclusionPatternMutationVariables>;

/**
 * __useDeleteEmailExclusionPatternMutation__
 *
 * To run a mutation, you first call `useDeleteEmailExclusionPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailExclusionPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailExclusionPatternMutation, { data, loading, error }] = useDeleteEmailExclusionPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmailExclusionPatternMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailExclusionPatternMutation, DeleteEmailExclusionPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailExclusionPatternMutation, DeleteEmailExclusionPatternMutationVariables>(DeleteEmailExclusionPatternDocument, options);
      }
export type DeleteEmailExclusionPatternMutationHookResult = ReturnType<typeof useDeleteEmailExclusionPatternMutation>;
export type DeleteEmailExclusionPatternMutationResult = Apollo.MutationResult<DeleteEmailExclusionPatternMutation>;
export type DeleteEmailExclusionPatternMutationOptions = Apollo.BaseMutationOptions<DeleteEmailExclusionPatternMutation, DeleteEmailExclusionPatternMutationVariables>;
export const CreateEmailExclusionPatternDocument = gql`
    mutation CreateEmailExclusionPattern($input: CreateEmailExclusionPatternInput!) {
  createEmailExclusionPattern(input: $input) {
    emailExclusionPattern {
      id
      emailPattern
      userStoreId
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateEmailExclusionPatternMutationFn = Apollo.MutationFunction<CreateEmailExclusionPatternMutation, CreateEmailExclusionPatternMutationVariables>;

/**
 * __useCreateEmailExclusionPatternMutation__
 *
 * To run a mutation, you first call `useCreateEmailExclusionPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailExclusionPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailExclusionPatternMutation, { data, loading, error }] = useCreateEmailExclusionPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailExclusionPatternMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailExclusionPatternMutation, CreateEmailExclusionPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailExclusionPatternMutation, CreateEmailExclusionPatternMutationVariables>(CreateEmailExclusionPatternDocument, options);
      }
export type CreateEmailExclusionPatternMutationHookResult = ReturnType<typeof useCreateEmailExclusionPatternMutation>;
export type CreateEmailExclusionPatternMutationResult = Apollo.MutationResult<CreateEmailExclusionPatternMutation>;
export type CreateEmailExclusionPatternMutationOptions = Apollo.BaseMutationOptions<CreateEmailExclusionPatternMutation, CreateEmailExclusionPatternMutationVariables>;
export const IdpUsersDocument = gql`
    query IdpUsers($filter: IdpUserFilter, $condition: IdpUserCondition, $orderBy: [IdpUsersOrderBy!], $after: Cursor) {
  filtered: idpUsers(
    filter: $filter
    condition: $condition
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      firstName
      lastName
      email
      status
      createdAt
      createdBy
      updatedAt
      updatedBy
      emailVerified
      isAffectedByExclusionPattern
    }
  }
  nonFiltered: idpUsers(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useIdpUsersQuery__
 *
 * To run a query within a React component, call `useIdpUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIdpUsersQuery(baseOptions?: Apollo.QueryHookOptions<IdpUsersQuery, IdpUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpUsersQuery, IdpUsersQueryVariables>(IdpUsersDocument, options);
      }
export function useIdpUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpUsersQuery, IdpUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpUsersQuery, IdpUsersQueryVariables>(IdpUsersDocument, options);
        }
export type IdpUsersQueryHookResult = ReturnType<typeof useIdpUsersQuery>;
export type IdpUsersLazyQueryHookResult = ReturnType<typeof useIdpUsersLazyQuery>;
export type IdpUsersQueryResult = Apollo.QueryResult<IdpUsersQuery, IdpUsersQueryVariables>;